var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M43.4173 22.7087C43.4173 33.9433 34.04 43.1156 22.3914 43.1156C10.7427 43.1156 1.36544 33.9433 1.36544 22.7087C1.36544 11.4742 10.7427 2.30184 22.3914 2.30184C34.04 2.30184 43.4173 11.4742 43.4173 22.7087Z",
    fill: "#FFE454",
    stroke: "#4E5866",
    strokeWidth: 2.73089
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M22.806 10.083L25.3279 17.63L25.6396 18.5627H26.623H34.6756L28.1941 23.1415L27.3653 23.727L27.6869 24.6895L30.1831 32.1595L23.5939 27.5045L22.806 26.948L22.0182 27.5045L15.429 32.1595L17.9252 24.6895L18.2468 23.727L17.418 23.1415L10.9365 18.5627H18.9891H19.9725L20.2842 17.63L22.806 10.083Z",
    fill: "white",
    stroke: "#4E5866",
    strokeWidth: 2.73089
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.c457327ea5ac4d2c7824c73fa140f7fb.svg";
export { ForwardRef as ReactComponent };